import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  imports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: "app-question-stepper",
  templateUrl: "./question-stepper.component.html",
})
export class QuestionStepperComponent {
  @Input() noOfSteps: number;
  @Input() currentStepNumber: number;
}
